import _ from "underscore";

export default {
  dataTableInitFilterListByBoolean: function (
    attr,
    table,
    listFilterElement,
    booleanFilterElement,
    filterCb,
    ajaxUpdateCb
  ) {
    if ($(table).attr(attr) === undefined) {
      return;
    }

    var wrapper = $(table).closest(".dataTables_wrapper");
    let listSelect = wrapper.find(listFilterElement);

    // ajax filter
    if (listSelect.data("ajax")) {
      // store the original data-ajax attribute if not already set
      if (!listSelect.data("ajax-original")) {
        listSelect.data("ajax-original", listSelect.data("ajax"));
      }
      wrapper.find(booleanFilterElement).on("change", function () {
        var booleanFilterValue = $(this).val();
        //update the data-ajax attribute of listFilterElement based on the filterCb
        listSelect.data(
          "ajax",
          ajaxUpdateCb(listSelect.data("ajax-original"), booleanFilterValue)
        );

        // trigger the ajax-change event on the listSelect to clear the tomselect state
        listSelect.trigger("ajax-change");
      });
    } else {
      // non-ajax filter
      var list = wrapper.find(listFilterElement + " option");

      wrapper.find(booleanFilterElement).on("change", function () {
        var booleanFilterValue = $(this).val();
        var selectValue = listSelect.val();
        listSelect.find("option").remove();

        var filteredList = list;

        if (booleanFilterValue !== "") {
          filteredList = _.filter(filteredList, function (option) {
            return filterCb(option, booleanFilterValue);
          });
        }

        if (!_.findWhere(filteredList, { value: selectValue })) {
          selectValue = "";
        }

        listSelect
          .append(filteredList)
          .val(selectValue)
          .trigger("change")
          .trigger("chosen:updated");
      });
    }
  },
};
